import React from 'react';

const TermsPage = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
    <h1 className="font-heading font-bold text-3xl text-white mb-8">Terms & Conditions</h1>
    <div className="max-w-none space-y-6 text-slate-400">
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">1. Acceptance</h2>
        <p>
          By accessing or using Stranger69.net (“the Platform”), you agree to these Terms & Conditions.
          If you do not agree, do not use the Platform.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">2. Eligibility</h2>
        <p>
          You must be at least 18 years old to use the Platform. By using the Platform, you represent
          that you meet this requirement. We may verify age and reserve the right to suspend accounts
          that do not comply.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">3. Accounts & Subscription</h2>
        <p>
          Users and service providers register with email and password. Subscription fees (e.g. ₹2500
          for users, ₹5000 for providers) grant access for the stated period. Fees are non-refundable
          except where required by law. You are responsible for keeping your account secure.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">4. Conduct</h2>
        <p>
          You must not use the Platform for illegal activity, harassment, fraud, or to harm others.
          Respect boundaries and consent. We may suspend or terminate accounts that violate these
          terms or our community standards.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">5. Service Provider Relationship</h2>
        <p>
          The Platform connects users with service providers. We do not employ providers. Any agreement
          between you and a provider (including payment for services) is between you and them. We are
          not liable for their conduct or any offline arrangements.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">6. Intellectual Property</h2>
        <p>
          Stranger69.net and its branding, design, and content are owned by us. You may not copy,
          scrape, or use them without permission.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">7. Limitation of Liability</h2>
        <p>
          The Platform is provided “as is”. We are not liable for indirect, incidental, or consequential
          damages arising from your use of the Platform or interactions with other users.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">8. Changes</h2>
        <p>
          We may update these Terms from time to time. Continued use after changes constitutes acceptance.
          Material changes will be communicated via the Platform or email where appropriate.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">9. Contact</h2>
        <p>
          For questions about these Terms, contact us via the Contact page.
        </p>
      </section>
    </div>
  </div>
);

export default TermsPage;
